import { useState } from 'react';

export const useAnimatedVisibility = (isOpen: boolean) => {
  const [isVisible, setVisible] = useState<boolean>(false);

  function onAnimationEnd() {
    if (!isOpen) {
      setVisible(false);
    }
  }

  if (isOpen && !isVisible) {
    setVisible(true);
  }

  return {
    isVisible,
    onAnimationEnd,
  };
};
